import './JoinGame.scss';
import React, {useEffect, useState} from 'react';
import {Redirect, useParams} from 'react-router';
import {_httpInstance as httpGameManager} from '../services/game-managers/HttpGameManager';

/**
 * props:
 *   gameKey
 */
const JoinGame = props => {
  const gameKey = useParams().gameKey;
  const [gameType, setGameType] = useState();

  useEffect(() => {
    if (!gameKey) {
      setGameType(null);
    }
    if (gameType === undefined) {
      httpGameManager.joinGame(gameKey)
          .then(rsp => setGameType(rsp.gameType || null));
    }
  }, [gameKey, gameType]);

  if (gameType) {
    return (
      <Redirect to={{pathname: `/games/${gameType}`, state: {join: gameKey}}} />
    );
  }

  return (
    <div className='JoinGame'>
      <div className='section'>
        <div className='subtitle'>
          {gameType === null ? 'Game not found' : 'Joining game...'}
        </div>
      </div>
    </div>
  );
};


export default JoinGame;
